module.exports = function (a) {
    if(window.fapPopupWin) {
        $('.icon-headphones').addClass('icon-plus-sign').removeClass('icon-headphones');
    }
};